export const GenericFormEvents = {
    // modales
    modalFormularioGenerico: 'modalFormularioGenerico',

};
